export const PRStatus = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  PARKED: 'On Hold',
  ARCHIVE: 'Archive',
}

export const GCPRStatus = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  ARCHIVE: 'Archive',
}

export const PRApprovalType = {
  TECHNICAL_PROJECT_MANAGER: 'Technical Project Manager',
  COMMERCIAL_PROJECT_MANAGER: 'Commercial Project Manager',
  HSP_2: 'HSP 2',
  HSP_1: 'HSP 1',
  TECHNICAL_3: '3T',
  COMMERCIAL_3: '3C',
  LOGISTIC: 'Logistic',
  LICENSE_MANAGER: 'License Manager',
}

export const PRHistoryType = {
  WORK_INSTRUCTION_ISSUED: 'Work Instruction Issued',
  WORK_INSTRUCTION_ACCEPTED: 'Work Instruction Accepted',
  WORK_INSTRUCTION_REMINDER_SENT: 'Work Instruction Reminder Sent',
}

// The PR submission history is a generic log; these are the types the
// "Work Instruction – History & Documents" modal shows.
export const WORK_INSTRUCTION_HISTORY_TYPES = [
  PRHistoryType.WORK_INSTRUCTION_ISSUED,
  PRHistoryType.WORK_INSTRUCTION_ACCEPTED,
  PRHistoryType.WORK_INSTRUCTION_REMINDER_SENT,
]

export const GCPRLicenseType = {
  NEW: 'New',
  MIGRATION: 'Migration',
  RENEW: 'Renew',
  CHANGE_OF_SCOPE: 'Change of Scope',
}
